import React, { useState, useEffect } from "react";
import { Modal, Checkbox, Avatar, List, Input, Button } from "antd";
import "./AssignToModal.css";

const AssignToModal = ({
  visible,
  onCancel,
  onSave,
  selectedUsers = [],
  users = [],
}) => {
  // console.log("selectedUsersAssignToModal", selectedUsers)
  const [localSelected, setLocalSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (Array.isArray(selectedUsers)) {
      setLocalSelected(selectedUsers);
    } else {
      setLocalSelected([]);
    }
  }, [selectedUsers]);

  const handleUserToggle = (user) => {
    console.log("selected>>>>", user)
    const exists = localSelected.some((u) => u.id === user.id);
    if (exists) {
      setLocalSelected((prev) => prev.filter((u) => u.id !== user.id));
    } else {
      setLocalSelected((prev) => [...prev, user]);
    }
  };

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const isChecked = (user) =>
    localSelected.some((u) => u.id === user.id);

  return (
    <Modal
      title="Assign To"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={() => onSave(localSelected)}
        >
          Save
        </Button>,
      ]}
    >
      <Input
        placeholder="Search by name"
        value={searchTerm}
        className="assignToSearch"
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 12 }}
      />

      <List
        itemLayout="horizontal"
        dataSource={filteredUsers}
        renderItem={(user) => (
          <List.Item
            actions={[
              <Checkbox
                checked={isChecked(user)}
                onChange={() => handleUserToggle(user)}
              />,
            ]}
          >
            <List.Item.Meta
              avatar={<Avatar src={user?.profile_image || user?.avatar} />}
              title={user.name}
              description={user.email}
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default AssignToModal;
